import { z } from 'zod';
import { studioProductSchema } from '../../supabase/functions/wersee-ai/studioContract';
import { safeSessionStorage } from './browserStorage';

const collectionSchema = z.object({
  createdAt: z.number(),
  projectId: z.uuid().optional(),
  prompt: z.string().max(4000),
  message: z.string().max(700),
  products: z.array(studioProductSchema).min(1).max(3),
  progress: z.array(z.object({
    id: z.uuid(),
    coverUrl: z.url().optional(),
    bannerUrl: z.url().optional(),
    thumbnailUrls: z.array(z.url()).max(5).optional(),
    pageCount: z.number().int().positive().optional(),
    pdfReference: z.string().regex(/^wersee-object:\/\/[a-f0-9-]{36}$/i).optional(),
    draftSaved: z.boolean().optional(),
    complete: z.boolean().optional(),
  }).strict()).min(1).max(3),
}).strict();
export type StudioCollection = z.infer<typeof collectionSchema>;
const keyFor = (userId: string) => `wersee:studio-collection:v1:${userId}`;

export function readStudioCollection(userId: string): StudioCollection | null {
  try {
    const parsed = collectionSchema.safeParse(JSON.parse(safeSessionStorage.getItem(keyFor(userId)) || 'null'));
    if (parsed.success && Date.now() - parsed.data.createdAt < 24 * 60 * 60 * 1000) return parsed.data;
  } catch { /* A corrupt or unavailable browser cache never blocks creation. */ }
  safeSessionStorage.removeItem(keyFor(userId));
  return null;
}
export function writeStudioCollection(userId: string, collection: StudioCollection) {
  safeSessionStorage.setItem(keyFor(userId), JSON.stringify(collection));
}
export function clearStudioCollection(userId: string) {
  safeSessionStorage.removeItem(keyFor(userId));
}
